import React from "react";
import { useSelector, useDispatch } from "react-redux";
import AmountPrice from '../../Components/AmountPrice/AmountPrice';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import {
    getSelectedConfigurationMode
} from '@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Selectors';
import { createPricePropsFromState, createAmountPropsFromState } from '@configuratorware/configurator-frontendgui/App/Shared/Containers/AmountPrice';
import { setVisible } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import { first, get, values } from "lodash";
import {
    getShowRequestQuoteButtonWithLevel,
} from "../../Reducers/Configurator/Selectors";

const CustomAmountPriceContainer = (props) => {
    const dispatch = useDispatch()
    const selectedDesignViewIdentifier = useSelector(state => get(state, "designView.designViews[0].identifier", null));
    const configurator = useSelector(state => get(state, 'configurator', {}));
    const state = useSelector(state => state);
    const getScreenshotImage = async () => {
        const screenshot = await Services.visualization.getScreenshots();
        return selectedDesignViewIdentifier ?
            first(values(screenshot))[selectedDesignViewIdentifier]
            : null;
    }

    return (<AmountPriceContainer
        {...props}
        Component={AmountPrice}
        showReceiveOfferForm={getShowRequestQuoteButtonWithLevel(state.configurator.configuration.customdata.level_visibility)}
        hasDesign={state.configurator.hasDesign}
        selectedMode={getSelectedConfigurationMode(state)}
        vatNotice={!getConf('displayNetPrices', false)
            ? t('amountPrice.vatNotice')
            : t('amountPrice.vatNoticeNet')}
        boxed={true}
        {...createAmountPropsFromState(configurator)}
        {...createPricePropsFromState(configurator)}
        getScreenshotImage={getScreenshotImage}
        updateGlobalLoader={(flag) => dispatch(setVisible('globalLoader', flag))}
    />)
}

export default CustomAmountPriceContainer
